export const ProjectTypeValues = ['OPEN_SOURCE', 'SIDE_PROJECT'];
//# sourceMappingURL=project-type.js.map